export const ROLE_LABELS = {
  member: "Member",
  facility_manager: "Facility Representative",
  chapter_manager: "Chapter Secretary",
  regional_manager: "Regional Secretary",
  national_manager: "National Manager",
  super_admin: "Super Administrator",
};

export const isNationalLevel = (role) => ["national_manager", "super_admin"].includes(role);
export const canApproveRegional = (role) => ["regional_manager", "national_manager", "super_admin"].includes(role);

export const STATUS_META = {
  deceased: { label: "Deceased", cls: "bg-slate-200 text-slate-900 dark:bg-slate-800 dark:text-slate-100" },
  incomplete: { label: "Incomplete", cls: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300" },
  pending_facility: { label: "Pending Facility", cls: "bg-orange-100 text-orange-800 dark:bg-orange-500/15 dark:text-orange-300" },
  pending_regional: { label: "Pending Regional", cls: "bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-400" },
  pending_national: { label: "Pending National", cls: "bg-blue-100 text-blue-800 dark:bg-blue-500/15 dark:text-blue-300" },
  approved: { label: "Approved", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-500/15 dark:text-emerald-400" },
  rejected: { label: "Rejected", cls: "bg-red-100 text-red-800 dark:bg-red-500/15 dark:text-red-400" },
};

export const isLimitedMemberView = (role) => ["facility_manager", "chapter_manager"].includes(role);
export const isManager = (role) => role && role !== "member";

export const MEMBER_TYPE_LABELS = { public: "Public Sector Worker", private: "Private Member", intern: "Intern" };
export const memberTypeLabel = (t) => MEMBER_TYPE_LABELS[t || "public"] || t;

export const ARCHIVE_REASONS = ["Retired", "Resigned", "Deceased", "Transferred out", "Duplicate record"];

export const CHAPTERS = [
  { code: "KBTH", prefix: "0101 MOH", name: "Korle Bu Teaching Hospital" },
  { code: "CCTH", prefix: "0313 MOH", name: "Cape Coast Teaching Hospital" },
  { code: "HTH", prefix: "0504 MOH", name: "Ho Teaching Hospital" },
  { code: "KATH", prefix: "0613 MOH", name: "Komfo Anokye Teaching Hospital" },
  { code: "STH", prefix: "0712 MOH", name: "Sunyani Teaching Hospital" },
  { code: "TTH", prefix: "0813 MOH", name: "Tamale Teaching Hospital" },
];
